// @ts-nocheck
import PhosphorRegular from '@phosphor-icons/web/src/regular/Phosphor.ttf';
import PhosphorFill from '@phosphor-icons/web/src/fill/Phosphor-Fill.ttf';
import PhosphorBold from '@phosphor-icons/web/src/bold/Phosphor-Bold.ttf';
export default `
/* Regular */
@font-face {
  src: url(${PhosphorRegular});
  font-family: Phosphor;
}
/* Fill */
@font-face {
  src: url(${PhosphorFill});
  font-family: Phosphor-Fill;
}
/* Bold */
@font-face {
  src: url(${PhosphorBold});
  font-family: Phosphor-Bold;
}
`;
//# sourceMappingURL=fontFace.js.map